/*
    APPROVE_ISSUEDINVOICE = "approve_issuedinvoice", "Can approve IssuedInvoice"
    APPROVE_ESTIMATE = "approve_estimate", "Can approve Estimate"
    APPROVE_PAYMENT = "approve_payment", "Can approve Payment"
    APPROVE_ORDER = "approve_order", "Can approve Order"
    ASSIGN_PIC = "assign_pic", "Can assign PIC"
    ASSIGN_AGENCY_PIC = "assign_agency_pic", "Can assign Agency PIC"

    APP_CREATE_ORDERREQUEST = "app_create_orderrequest", "Can create OrderRequest"
*/
export const Permission = {
  APPROVE_ISSUEDINVOICE: 'approve_issuedinvoice',
  APPROVE_ESTIMATE: 'approve_estimate',
  APPROVE_PAYMENT: 'approve_payment',
  APPROVE_ORDER: 'approve_order',
}

export const getTransitionUrl = (req: ApprovalRequest) => {
  switch (req.permissionCode) {
    case Permission.APPROVE_ESTIMATE:
      return `/orders/${req.order?.id}/estimate/`
    case Permission.APPROVE_ISSUEDINVOICE:
      return `/orders/${req.order?.id}/invoice/`
    case Permission.APPROVE_PAYMENT:
      return `/payments/${req.source?.id}/`
    default:
      return ''
  }
}

export const getApprovalRequestName = (req: ApprovalRequest) => {
  const { t } = useI18n()
  switch (req.permissionCode) {
    case Permission.APPROVE_ESTIMATE:
      return t('見積書承認')
    case Permission.APPROVE_ORDER:
      return t('受注承認')
    case Permission.APPROVE_PAYMENT:
      return t('支払承認')
    case Permission.APPROVE_ISSUEDINVOICE:
      return t('請求書承認')
    default:
  }
}

export const useApprovalRequestStore = defineStore('approvalRequest', () => {
  const api = useAPI()
  const approvalRequestCount = ref(0)

  async function refresh() {
    const ret = await api.approvalRequests().count()
    approvalRequestCount.value = ret.count
  }

  return { approvalRequestCount: readonly(approvalRequestCount), refresh }
})

export const getApprovalObjectClientName = (req: ApprovalRequest): string => {
  switch (req.permissionCode) {
    case Permission.APPROVE_ESTIMATE:
      return req.order?.organizationInfo?.name || ''
    case Permission.APPROVE_ISSUEDINVOICE:
      return req.order?.organizationInfo?.name || ''
    case Permission.APPROVE_PAYMENT:
      return req.source?.partner?.name || ''
    default:
      return ''
  }
}
